import {store} from "../../store";
import * as actionTypes from "./actionTypes";
import {ThresholdService} from "../../../api/thresholdService";
import {toastError, toastSuccess, toastWarning} from "../../../shared/components/toast/Toast";

export const getThresholdData = (integrationId, page, rowsPerPage, sortBy, filter) => {
    const sortParts = sortBy.split(',')
    const ruleName = filter.name.value
    const msisdn = filter.telephoneNumber.value
    const ruleType = filter.type.value
    const serviceType = filter.typeService.value
    const state = filter.statusText.value
    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_THRESHOLD_DATA, value: true})
        ThresholdService.fetchThresholdData(integrationId, page, rowsPerPage, sortParts[0], sortParts[1].toUpperCase(),
            ruleType, msisdn, ruleName, state, serviceType)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_THRESHOLD_DATA,
                    payload: res.data.tableData ?? [],
                    count: res.data.totalElements ?? 0
                })
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_THRESHOLD_DATA, value: false})
            })
    }
}

export const getThresholdDetails = (ruleId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatchRuleDetails(dispatch, ruleId, integrationId)
    }
};

export const getAddToSimData = (ruleId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.SET_SIMS_TO_ADD_OR_DELETE_VALUE, name: "loading", payload: true})
        ThresholdService.fetchAddSimToRuleData(ruleId, integrationId)
            .then((res) => {
                dispatch({type: actionTypes.SET_SIMS_TO_ADD_OR_DELETE_VALUE, name: "data", payload: res.data})
            })
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_SIMS_TO_ADD_OR_DELETE_VALUE, name: "loading", payload: false})
            })
    }
};

export const addSimToRule = (ruleId, msisdnList) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.SET_SIMS_ADD_OR_DELETE_CONFIRM_LOADING, value: true})
        ThresholdService.addSimToRule(ruleId, integrationId, msisdnList)
            .then((res) => {
                if (res.data.length) {
                    toastWarning(`SIM che non vengono aggiunte perchè fanno parte di altre regole: ${res.data.map(sim => `+${sim.msisdn}`).join(', ')}`)
                } else {
                    toastSuccess("Sim aggiunta con successo")
                }
                // For now we dont need this since it goes back to the table view
                // setTimeout(() => dispatchRuleDetails(dispatch, ruleId, integrationId), 1000)
            })
            .catch(err => {
                console.log(err)
                toastError("Si è verificato un errore")
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_SIMS_ADD_OR_DELETE_CONFIRM_LOADING, value: false})
            })
    }
}

export const getSimsToDelete = (ruleId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId
    return (dispatch) => {
        dispatch({type: actionTypes.SET_SIMS_TO_ADD_OR_DELETE_VALUE, name: "loading", payload: true})
        ThresholdService.fetchSimsToDelete(ruleId, integrationId)
            .then((res) => {
                dispatch({type: actionTypes.SET_SIMS_TO_ADD_OR_DELETE_VALUE, name: "data", payload: res.data})
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_SIMS_TO_ADD_OR_DELETE_VALUE, name: "loading", payload: false})
            })
    }
}

export const fetchSoglieAddOrRemoveSimCollaborators = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.SET_SIMS_TO_ADD_OR_DELETE_VALUE, name: "collaboratorsLoading", payload: true})
        ThresholdService.fetchSoglieAddRemoveSimCollaboratorsFilter(integrationId)
            .then((res) => {
                dispatch({type: actionTypes.SET_SIMS_TO_ADD_OR_DELETE_VALUE, name: "collaborators", payload: res.data})
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.SET_SIMS_TO_ADD_OR_DELETE_VALUE,
                    name: "collaboratorsLoading",
                    payload: false
                })
            })
    }
}

export const deleteSelectedSims = (ruleId, msisdnList) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.SET_SIMS_ADD_OR_DELETE_CONFIRM_LOADING, value: true})
        ThresholdService.deleteSelectedSims(ruleId, integrationId, msisdnList)
            .then(() => {
                toastSuccess("Operazione avvenuta con successo")
                // For now we dont need this since it goes back to the table view
                // setTimeout(() => dispatchRuleDetails(dispatch, ruleId, integrationId), 1000)
            })
            .catch((e) => {
                console.log(e);
                toastError("Si è verificato un errore")
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_SIMS_ADD_OR_DELETE_CONFIRM_LOADING, value: false})
            })
    }
}

const dispatchRuleDetails = (dispatch, ruleId, integrationId) => {
    dispatch({type: actionTypes.SET_THRESHOLD_DETAILS_LOADING, value: true})

    ThresholdService.fetchThresholdDetails(ruleId, integrationId)
        .then((res) => {
            dispatch({
                type: actionTypes.FETCH_THRESHOLD_DETAILS,
                payload: res.data
            })
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            dispatch({type: actionTypes.SET_THRESHOLD_DETAILS_LOADING, value: false})
        })
}

export const updateRuleAction = (ruleId, updateRuleRequestDto, page, rowsPerPage, sortBy, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({type: actionTypes.UPDATE_RULE_LOADING, value: true})

        ThresholdService.updateRule(ruleId, integrationId, updateRuleRequestDto)
            .then(() => {
                dispatch({type: actionTypes.UPDATE_RULE, payload: updateRuleRequestDto})
                dispatch(getThresholdData(integrationId, page, rowsPerPage,
                    sortBy, filter))
                toastSuccess("Regola aggiornata correttamente.")
            })
            .catch((err) => {
                console.log(err.response.data)
                for (let i = 0; i < err.response.data.errors.length; i++) {
                    toastError(err.response.data.errors[i].defaultMessage)
                }
            })
            .finally(() => {
                dispatch({type: actionTypes.UPDATE_RULE_LOADING, value: false})
            })
    }
}

export const deleteRules = (ruleIds, page, rowsPerPage, sortBy, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    let errorMessage = "Regola eliminata con successo.";
    if (ruleIds.length > 1)
        errorMessage = "Regole eliminate con successo."

    return (dispatch) => {
        dispatch({type: actionTypes.DELETE_RULES_LOADING, value: true})
        ThresholdService.deleteRules(integrationId, ruleIds)
            .then(() => {
                setTimeout(() => dispatch(getThresholdData(integrationId, page, rowsPerPage,
                    sortBy, filter)), 2000)
                toastSuccess(errorMessage)
            })
            .catch((err) => {
                console.log(err.response.data)
                toastError("Si è verificato un errore durante l'eliminazione delle regole.")
            })
            .finally(() => {
                dispatch({type: actionTypes.DELETE_RULES_LOADING, value: false})
            })
    }
}

export const deleteThresholds = (ruleId, thresholdIds) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return (dispatch) => {
        dispatch({type: actionTypes.THRESHOLDS_LOADING, value: true})
        ThresholdService.deleteThresholds(ruleId, integrationId, thresholdIds)
            .then(() => {
                setTimeout(() => dispatch(getThresholdDetails(ruleId)), 2000)
                toastSuccess("Soglia eliminata con successo")
            })
            .catch((err) => {
                console.log(err.response.data)
                toastError("Si è verificato un errore durante la cancellazione della soglia")
            })
            .finally(() => {
                dispatch({type: actionTypes.THRESHOLDS_LOADING, value: false})
            })
    }
}

export const getSimToAssociateToNewRule = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_SIMS_NEW_SOGLIA, payload: true})
        ThresholdService.fetchSimsToAssociateNewRule(integrationId)
            .then(res => {
                dispatch({
                    type: actionTypes.FETCH_SIMS_NEW_SOGLIA,
                    payload: res.data
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_SIMS_NEW_SOGLIA, payload: false})
            })
    }
}

export const addThresholdsToRule = (ruleId, thresholds) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return dispatch => {
        ThresholdService.addThresholdsToRule(ruleId, integrationId, thresholds)
            .then(() => {
                dispatch(getThresholdDetails(ruleId))
                toastSuccess("Soglie aggiunte con successo")
            })
            .catch(e => {
                if (e.response?.status === 409) {
                    toastError("Non è possibile creare una soglia uguale ad una già esistente")
                } else {
                    toastError("Errore durante l'aggiunta delle soglie")
                }
            })
    }
}

export const updateThresholdsForRule = (ruleId, thresholds) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return dispatch => {
        dispatch({type: actionTypes.THRESHOLDS_LOADING, value: true})
        ThresholdService.updateThresholdsForRule(ruleId, integrationId, thresholds)
            .then(() => {
                dispatch(getThresholdDetails(ruleId))
                toastSuccess("Soglia modificata con successo")
            })
            .catch(e => {
                console.log(e)
                toastError("Errore durante la modifica delle soglie")
            })
            .finally(() => {
                dispatch({type: actionTypes.THRESHOLDS_LOADING, value: false})
            })
    }
}

export const getCreateRegolaMenuItems = (ruleType, unitType, service, traffic, period, name, setSelectValue, selectedValues, formElements) => {
    return dispatch => {
        dispatch({type: actionTypes.GET_CREATE_REGOLA_MENU_ITEMS, name: 'loading', payload: true})
        ThresholdService.fetchCreateRegolaMenuItems(ruleType, unitType, service, traffic, period)
            .then(res => {
                dispatch({
                    type: actionTypes.GET_CREATE_REGOLA_MENU_ITEMS,
                    name: name,
                    payload: res.data.createRuleOptions
                })
                if (res.data.createRuleOptions.length === 1) {
                    setSelectValue(name, res.data.createRuleOptions[0].value, selectedValues, formElements)
                }
            })
            .catch(e => {
                console.log(e.response.data)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_CREATE_REGOLA_MENU_ITEMS, name: 'loading', payload: false})
            })
    }
}

export const suspendOrActivateRule = (id, updateRuleRequestDto, page, rowsPerPage, sortBy, filter) => {
    return (dispatch) => {
        dispatch(updateRuleAction(id, updateRuleRequestDto, page, rowsPerPage, sortBy, filter))
        setTimeout(() => dispatch(getThresholdDetails(id)), 2000)
    }
}
